import { render, staticRenderFns } from "./SalesPhysicalStoreList.vue?vue&type=template&id=1c1840d8&scoped=true&"
import script from "./SalesPhysicalStoreList.vue?vue&type=script&lang=js&"
export * from "./SalesPhysicalStoreList.vue?vue&type=script&lang=js&"
import style0 from "./SalesPhysicalStoreList.vue?vue&type=style&index=0&id=1c1840d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1840d8",
  null
  
)

export default component.exports